module.exports = __webpack_public_path__ + "img/pmLogo.e89a1f76.png";